import axios from "axios";

/**
 * Fetches the immutable version snapshots of a legal document (most recent
 * first). Distinct from /history which returns the mutable live rows.
 * @param {number} docId - The legal document id
 * @returns {Promise<Array>} List of snapshot objects
 */
async function fetchLegalVersions(docId) {
    const { data } = await axios.get(`/admin/legal/${docId}/versions`);
    return Array.isArray(data) ? data : [];
}

/**
 * Fetches a single immutable snapshot by version string (used for the diff).
 * @param {number} docId - The legal document id
 * @param {string} version - The version label (e.g. "3.0")
 * @returns {Promise<Object>} The snapshot object
 */
async function fetchLegalVersion(docId, version) {
    const { data } = await axios.get(`/admin/legal/${docId}/versions/${version}`);
    return data;
}

export { fetchLegalVersions, fetchLegalVersion };
